module.exports = __webpack_public_path__ + "fonts/glyphicons-halflings-regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.ttf
// module id = 433
// module chunks = 1